import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useTranslation } from 'react-i18next';

import Button from 'components/button/Button';
import { RichTextEditorToolbarPluginProps } from 'components/editor/RichTextEditor.types';
import { cleanHTMLContent } from 'components/editor/RichTextEditor.utils';

interface CleanHTMLButtonProps {
  disabled: boolean;
  toolbarSettings: RichTextEditorToolbarPluginProps['toolbarSettings'];
}

const CleanHTMLButton = ({
  disabled,
  toolbarSettings: { features },
}: CleanHTMLButtonProps) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();

  if (!features?.cleanHTML) {
    return null;
  }

  const handleOnClick = () => {
    editor.update(() => {
      cleanHTMLContent();
    });
  };

  return (
    <Button
      // aria-label={t('form.editor.buttons.cleanHTML')}
      className="toolbar-item"
      data-testid="toolbar-button-cleanHTML"
      disabled={disabled}
      onClick={handleOnClick}
    >
      {t('form.editor.buttons.cleanHTML')}
    </Button>
  );
};

export default CleanHTMLButton;
